/**
 * VariableChips Component
 * Clickable chips for inserting template variables
 */

import { memo } from 'react';
import { TEMPLATE_VARIABLES } from '@/constants/templateConstants';
import type { IVariableChipsProps } from '@/@types/messageTemplates';

function VariableChips({ onVariableClick }: IVariableChipsProps) {
  const handleClick = (key: string) => {
    onVariableClick(`{{${key}}}`);
  };

  return (
    <div className="space-y-3">
      {/* Lead Variables */}
      <div>
        <p className="text-xs text-muted-foreground mb-1.5">Lead</p>
        <div className="flex flex-wrap gap-1.5">
          {TEMPLATE_VARIABLES.lead.map(variable => (
            <button
              key={variable.key}
              type="button"
              onClick={() => handleClick(variable.key)}
              className="px-2 py-1 text-xs bg-muted hover:bg-muted/80 text-foreground rounded-md transition-colors border border-border hover:border-border-hover"
              title={variable.description}
            >
              {`{{${variable.key}}}`}
            </button>
          ))}
        </div>
      </div>

      {/* Property Variables */}
      <div>
        <p className="text-xs text-muted-foreground mb-1.5">Property</p>
        <div className="flex flex-wrap gap-1.5">
          {TEMPLATE_VARIABLES.property.map(variable => (
            <button
              key={variable.key}
              type="button"
              onClick={() => handleClick(variable.key)}
              className="px-2 py-1 text-xs bg-muted hover:bg-muted/80 text-foreground rounded-md transition-colors border border-border hover:border-border-hover"
              title={variable.description}
            >
              {`{{${variable.key}}}`}
            </button>
          ))}
        </div>
      </div>

      {/* Agent Variables */}
      <div>
        <p className="text-xs text-muted-foreground mb-1.5">Agent</p>
        <div className="flex flex-wrap gap-1.5">
          {TEMPLATE_VARIABLES.agent.map(variable => (
            <button
              key={variable.key}
              type="button"
              onClick={() => handleClick(variable.key)}
              className="px-2 py-1 text-xs bg-muted hover:bg-muted/80 text-foreground rounded-md transition-colors border border-border hover:border-border-hover"
              title={variable.description}
            >
              {`{{${variable.key}}}`}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export const VariableChipsMemo = memo(VariableChips);
